/** Parse US dollar inputs without silently accepting malformed comma grouping. */
export function moneyInputCents(value: unknown): number {
  const text = String(value ?? '').trim().replace(/^\$\s*/, '');
  if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(text)) return NaN;
  const cents = Math.round(Number(text.replaceAll(',', '')) * 100);
  return Number.isSafeInteger(cents) ? cents : NaN;
}
